module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/logo4m.8e154d4c.png";